import { Navigate, useLocation } from "react-router-dom";
import { getItem } from '../Services/localService';
import PermissionDeniedModal from "../Components/PermissionDeniedModal";
import { Utils } from "../Utils";
import { useDispatch } from "react-redux";
import { updateMenuTitle } from "../Store/Slices/sidebarSlice";

const ProtectedRoutes = ({ children }) => {
    let userPermissionData = getItem('userPermission')?.adminLevel;
    let currentUser = getItem("user") || {};
    let userProfile = currentUser?.Profile?.profile_name;
    let isToken = getItem('token');
    let location = useLocation();
    let dispatch = useDispatch();

    if (location.pathname.includes('data-hub')) {
        dispatch(updateMenuTitle('Data Hub'))
    } else {
        dispatch(updateMenuTitle('CRM'))
    }

    if (isToken && location.pathname.includes('settings/profiles')) {
        if (userPermissionData?.find(u => u.key === "profilesAccess")?.permision === false) {
            return <PermissionDeniedModal />
        }
    }
    if (isToken && location.pathname.includes('settings/roles-and-sharing')) {
        if (userPermissionData?.find(u => u.key === "rolesAndSharingAccess")?.permision === false) {
            return <PermissionDeniedModal />
        }
    }

    // if (isToken && (location.pathname.includes('settings/roles-and-sharing') ||
    //     location.pathname.includes('settings/profiles'))) {
    //     if (!userProfile?.toLowerCase()?.includes('admin')) {
    //         return <PermissionDeniedModal />
    //     }
    // }

    if (isToken && location.pathname.includes('/form-module/sub-form/')) {
        const basicPermissionData = getItem('modulePermission')?.basic;
        if (basicPermissionData) {
            let moduleId = location.pathname.split('/')[4];
            if (moduleId == 'create') {
                moduleId = location.pathname.split('/')[5];
                let response = basicPermissionData?.some(x => x?.id === moduleId && x.activities.create === true);
                if (!response) {
                    return <PermissionDeniedModal />
                }
            }
            if (moduleId == 'update') {
                moduleId = location.pathname.split('/')[5];
                let response = basicPermissionData?.filter((data) => data.id === moduleId && data.activities.edit === true);
                if (response.length === 0) {
                    return <PermissionDeniedModal />
                }
            }
            if (moduleId !== 'create' && moduleId !== 'update') {
                let response = basicPermissionData?.filter((data) => data.id === moduleId && data.activities.view === true);
                if (response.length === 0) {
                    return <PermissionDeniedModal />
                }
            }
        }
    }

    if (isToken && (location.pathname === '/' || location.pathname === '/auth/login' || location.pathname === '/auth/signup')) {
        return <Navigate to={Utils.getNavigationUrl(`dashboard`)} />
    } else if (!isToken) {
        // return <Navigate to="/" />
        return <Navigate to="/auth/login" />
    }

    return children;
}
export default ProtectedRoutes